import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const { t, isRTL } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="relative py-8 bg-black border-t border-white/10"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img 
              src={companyInfo.logo} 
              alt="SyrVerse" 
              className="h-8 object-contain"
            />
          </div>

          <p className="text-white/50 text-sm">
            © {currentYear} SyrVerse. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
